"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var app_1 = require("../app");
var format_price_1 = __importDefault(require("../../../utils/format-price/"));
exports.default = (function () {
    var context = (0, react_1.useContext)(app_1.CheckoutContext);
    if (!context)
        return null;
    var discountCode = context.discountCode, setDiscountCode = context.setDiscountCode, imageUrls = context.imageUrls, discountCodeError = context.discountCodeError, priceDiscount = context.priceDiscount;
    var _a = __read((0, react_1.useState)(false), 2), isSettingDiscountCode = _a[0], setSettingDiscountCode = _a[1];
    var discountCodeRef = (0, react_1.useRef)(null);
    var applyDiscountCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = discountCodeRef.current) === null || _a === void 0 ? void 0 : _a.value)) return [3 /*break*/, 2];
                    setSettingDiscountCode(true);
                    return [4 /*yield*/, setDiscountCode(discountCodeRef.current.value)];
                case 1:
                    _b.sent();
                    setSettingDiscountCode(false);
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var removeDiscountCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSettingDiscountCode(true);
                    return [4 /*yield*/, setDiscountCode('')];
                case 1:
                    _a.sent();
                    setSettingDiscountCode(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: 'margin-top-6 margin-bottom-6' },
        react_1.default.createElement("div", { className: 'h5' }, "Redeem a gift card or promo code"),
        react_1.default.createElement("div", { className: 'margin-top-4' },
            !discountCode && (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'input-group input-group-checkout' },
                    react_1.default.createElement("input", { className: 'input-group-field', type: 'text', ref: discountCodeRef, defaultValue: discountCode || '', placeholder: 'Discount Code or Gift Card', "aria-describedby": 'checkout-discount-code-error-message' }),
                    react_1.default.createElement("div", { className: 'input-group-button' },
                        react_1.default.createElement("button", { className: 'button', onClick: applyDiscountCode, style: { fontSize: '1.25em' }, disabled: isSettingDiscountCode },
                            isSettingDiscountCode && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("img", { style: { width: '1em', height: '1em' }, src: imageUrls.spinner }))),
                            !isSettingDiscountCode && react_1.default.createElement("img", { style: { width: '1em', height: '1em' }, src: imageUrls.arrowRight })))),
                discountCodeError && (react_1.default.createElement("p", { className: 'help-text is-invalid text-pastel-red', id: 'checkout-discount-code-error-message' }, discountCodeError)))),
            discountCode && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'applied-discount-code' },
                    isSettingDiscountCode && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("img", { style: { width: '1.25em', height: '1.25em', marginRight: '8px' }, src: imageUrls.spinnerBlack }))),
                    !isSettingDiscountCode && (react_1.default.createElement("a", { onClick: removeDiscountCode, style: { marginRight: '8px' } },
                        react_1.default.createElement("img", { style: { width: '1.5em', height: '1.5em' }, src: imageUrls.close }))),
                    discountCode),
                priceDiscount && priceDiscount !== '0.00' && (react_1.default.createElement("div", { className: 'font-lighter margin-top-4 margin-bottom-4', style: { fontSize: '14px' } },
                    "You will save ",
                    (0, format_price_1.default)(priceDiscount),
                    "!")))))));
});
